import React from 'react';
import { Button, Tooltip } from 'antd';
import { AccessControlEmployer } from '@/DTOS/AccessControlEmployer/Response/AccessControlEmployer';
import { EditOutlined} from '@ant-design/icons';

export const AccessControlEmployerColumn = (
  handleEdit: (record: AccessControlEmployer) => void
) => [
  
  {
    title: 'Employer Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Nume',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Referinta Card',
    dataIndex: 'cardReference',
    key: 'cardReference',
  },
  {
    title: 'Referinta Face',
    dataIndex: 'faceReference',
    key: 'faceReference',
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: AccessControlEmployer) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed: 'right'
  },
];
